import { useTranslation } from 'react-i18next'

/**
 * Shown when the hearts run out. Duolingo ends the lesson here and makes you
 * wait or pay for a refill; this one ends the lesson and carries on through the
 * funnel.
 *
 * That difference is deliberate and load-bearing. This screen sits immediately
 * before the account wall, so a dead end — any state the learner cannot leave
 * by pressing the obvious button — is a lost sale rather than a lesson in
 * perseverance. The copy frames it as the lesson being over, not as failure.
 */
export default function DuoOutOfHeartsSheet({
  onContinue,
}: {
  onContinue: () => void
}) {
  const { t } = useTranslation()

  return (
    <div
      className="animate-fade-up bg-duo-red-soft -mx-4 px-4 pt-4 pb-6"
      data-testid="lesson-out-of-hearts"
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          {/* An empty heart rather than the brand mark, matching the pips in
              the header that just ran out. */}
          <span
            aria-hidden="true"
            className="text-duo-red-text/50 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white"
          >
            <svg
              fill="none"
              height="24"
              stroke="currentColor"
              strokeLinejoin="round"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
              width="24"
            >
              <path d="M12 21s-7.5-4.7-9.6-9A5.6 5.6 0 0 1 12 6.2 5.6 5.6 0 0 1 21.6 12c-2.1 4.3-9.6 9-9.6 9Z" />
            </svg>
          </span>

          <div>
            <p className="text-duo-red-text text-xl font-extrabold">
              {t('pages.onboarding.v2.lesson.outOfHearts.title')}
            </p>

            <p className="text-duo-red-text mt-1 text-sm font-bold">
              {t('pages.onboarding.v2.lesson.outOfHearts.body')}
            </p>
          </div>
        </div>

        <button
          className="duo-button-wrong"
          data-testid="button-out-of-hearts-continue"
          onClick={onContinue}
          type="button"
        >
          {t('pages.onboarding.v2.lesson.outOfHearts.continue')}
        </button>
      </div>
    </div>
  )
}
